import type { FaireProductEntity } from "../../entity_types/product";

export const p_2ke2eml3x0: FaireProductEntity = {
  token: "p_2ke2eml3x0",
  type: "product",
  name: "Fairy Happy Birthday Greeting Card",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/4478dd97f8720625014c50bf9a34892e02e0d2c8e0b11ad69c8d32b1b69c50ee/1554872469.png",
  galleryImageUrls: [],
  priceDollars: 4.13,
  description:
    'Introducing our enchanting "Fairy Happy Birthday" Greeting Card, a magical way to make a child\'s special day even more extraordinary! Transport your little one to a realm of wonder and delight with this whimsical card that captures the charm and allure of fairyland.\n\n•Size: A2 5.5" x 4.25" \n•Features: Blank interior and coordinating envelope\n•Sentiment: Have A Fairy Happy Birthday',
  tags: [],
  msrpDollars: 8.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:02.042Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
